export function calculateCheckoutTaxes(subTotal, deliveryPrice, response) {
  const business = response.data ?? response;
  const metadata = Array.isArray(business.meta_data)
    ? Object.fromEntries(
        business.meta_data.map(({ meta_key, meta_value }) => [meta_key, meta_value])
      )
    : business.meta_data || {};

  const readRate = (key, apiKey) => {
    const value = business[apiKey] ?? metadata[key] ?? business[key];
    const rate = value == null || value === "" ? 0 : Number(value);
    if (!Number.isFinite(rate) || rate < 0 || rate > 100) {
      throw new Error("Invalid business tax percentage");
    }
    return rate;
  };

  const base = Number(subTotal) + Number(deliveryPrice);
  const round = (amount) => Math.round((amount + Number.EPSILON) * 100) / 100;
  const fees = [
    { label: "Service Fees", rate: 10 },
    { label: "Business Tax", rate: readRate("business_tax", "businessTaxRate") },
    {
      label: "Convention and Tourism Tax",
      rate: readRate("business_conv_tour_tax", "businessConvTourTaxRate"),
    },
  ].map((fee) => ({
    ...fee,
    amount: subTotal > 0 ? round((base * fee.rate) / 100) : 0,
  }));

  const totalFees = round(fees.reduce((sum, fee) => sum + fee.amount, 0));
  return {
    fees,
    totalRate: round(fees.reduce((sum, fee) => sum + fee.rate, 0)),
    totalFees,
    total: subTotal > 0 ? round(base + totalFees) : 0,
  };
}
